var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7289 3.50989L15.4889 7.02989C15.7289 7.51989 16.3689 7.98989 16.9089 8.07989L20.0989 8.60989C22.1389 8.94989 22.6189 10.4299 21.1489 11.8899L18.6689 14.3699C18.2489 14.7899 18.0189 15.5999 18.1489 16.1799L18.8589 19.2499C19.4189 21.6799 18.1289 22.6199 15.9789 21.3499L12.9889 19.5799C12.4489 19.2599 11.5589 19.2599 11.0089 19.5799L8.01893 21.3499C5.87893 22.6199 4.57893 21.6699 5.13893 19.2499L5.84893 16.1799C5.97893 15.5999 5.74893 14.7899 5.32893 14.3699L2.84893 11.8899C1.38893 10.4299 1.85893 8.94989 3.89893 8.60989L7.08893 8.07989C7.61893 7.98989 8.25893 7.51989 8.49893 7.02989L10.2589 3.50989C11.2189 1.59989 12.7789 1.59989 13.7289 3.50989Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.e2c21915faaa8f481dae47a6246c6267.svg";
export { ForwardRef as ReactComponent };